<template>
  <div class="lego-dropdown-check-wrap" v-click-outside="toggleItemOuter" :style="getWidthDropDown">
    <div
      class="dropdown-toggle"
      @click="toggleDropdown"
      :class="{ 'is-item-showing': isItemShowing }"
    >
      <c-label
        v-if="!dropdownText"
        ellipsis
        :inline="'block'"
        :color="getSelectedColor"
        :lineHeight="30"
      >
        {{ getSelectedText }}
      </c-label>
      <div
        v-if="dropdownText"
        class="lego-dropdown__selected"
        ref="widthDiv"
        :style="dropdownTitleStyle"
        v-lego-tooltip="{
          // arg: 'ellipsis',
          value: textToolTip,
          moreAction: 'clickToHide',
          position: 'top-left'
        }"
      >
        <div style="display: flex; margin-top: 4px">
          <span :style="styleTextSelected">
            <span style="text-overflow: ellipsis; width: 100%">{{ textSelected }}</span>
          </span>
          <span
            v-if="isMultiSelect"
            style="text-overflow: unset; min-width: max-content; margin-left: 3px"
            >{{ countSelected }}</span
          >
        </div>
        <!-- <lego-tooltip v-show="isShowTooltip" :mouseOver="true" :top="true">
          <slot name="tooltip">{{ textToolTip }}</slot>
        </lego-tooltip> -->
      </div>
      <lego-icon-wrapper class="lego-dropdown__title-icon">
        <lego-icon class="lego-dropdown__icon" icon="expand_menu" size="12px" :style="caretStyle" />
      </lego-icon-wrapper>
    </div>
    <div v-if="isItemShowing" class="dropdown-submenu" :style="getWidthDropDown">
      <!--<div v-if="isItemShowing && 0 < items.length" class="dropdown-submenu"> -->
      <div class="auto-complete__search-box">
        <lego-text-field
          ref="filterInput"
          v-model="filterText"
          searchable
          @input="filterTextOnInput"
          counter="100"
          :isCounter="false"
          :mutateInput="mutateInput"
          :placeholder="autoCompletePlaceholder"
        />
      </div>
      <div v-if="getFilterItems.length > 0" class="lego-dropdown__selectall-wrap">
        <div
          class="lego-dropdown__item lego-dropdown__selectall"
          @click="clickSelectAll"
          v-if="!filterText"
        >
          <lego-checkbox
            class="checkbox-wrapper"
            :indeterminate="selectAllChecked && selectAllCheckedIcon === 'indeterminate'"
            :checked="selectAllChecked"
            :checked-icon="selectAllCheckedIcon"
            @click="clickSelectAll"
            >{{ $t('label.all') }}</lego-checkbox
          >
        </div>
      </div>

      <div class="search-result" v-if="filterText">{{ searchResult }}</div>

      <c-scroll :style="{ maxHeight: heightScroll + 'px' }">
        <div v-if="!getFilterItems.length && items.length" class="no-result">
          {{ $t('label.noSearchResult') }}
        </div>

        <div
          v-for="(item, index) in getFilterItems"
          :class="{ 'check-item': true, selected: item.check }"
          :key="index"
          @click="itemCheckOnClick(item)"
        >
          <div class="checkbox">
            <lego-icon
              iconType="df"
              :icon="changeIcon(item)"
              sm
              @click.stop="itemCheckOnClick(item)"
            />
          </div>

          <c-label ellipsis style="width: calc(100% - 16px); padding-left: 10px">
            <div
              class="ellipsis"
              v-html="getTagText(item)"
              v-lego-tooltip:ellipsis="getTagText(item, true)"
            ></div>
          </c-label>
        </div>
      </c-scroll>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import cScroll from '../../cmp/cScroll/cScroll.vue';
// import NullWidget from '@/components/scpm/widgets/common/NullWidget';
import NullWidget from '@/containers/widget/components/NullWidget';
import i18nMixin from '@/mixins/i18n.mixin.js';
export default {
  components: { cScroll, NullWidget },
  emits: ['customClick', 'update:modelValue', 'clickAll', 'delete'],
  props: {
    modelValue: { type: Array, default: () => [] },
    rowId: { type: [Number, String] },
    items: { type: Array, default: () => [] },
    mutateInput: { type: Function, default: null },
    isSummary: { type: Boolean, default: false },
    isEventFiltering: { type: Boolean, default: false },
    dropdownText: { type: Boolean, default: false },
    eventFiltering: { type: Boolean, default: false },
    selectAll: { type: Boolean, default: false },
    hasSearchField: { type: Boolean, default: true },
    heightScroll: { type: Number, default: 200, required: false },
    placeholder: { type: String },
    autoCompletePlaceholder: { type: String }
  },
  data() {
    return {
      searchResult: '',
      filterText: '',
      selectedList: [],
      isItemShowing: false,
      textSelected: this.placeholder,
      countSelected: '',
      isMultiSelect: false,
      isShowTooltip: false,
      textToolTip: ''
    };
  },
  watch: {
    modelValue: {
      deep: true,
      handler(val) {
        this.selectedList = val;
        if (this.eventFiltering) {
          this.getSelectedItemText();
        }
      }
    }
  },
  computed: {
    selectAllChecked() {
      return this.selectedList.length > 0;
    },
    selectAllCheckedIcon() {
      if (this.hasSearchField) {
        return this.getFilterItems.every((item) => item.check === true)
          ? 'checked'
          : 'indeterminate';
      }
      return this.selectedList.length === this.items.length ? 'checked' : 'indeterminate';
    },
    dropdownTitleStyle() {
      if (this.selectedList.length === 0) {
        this.textSelected = this.placeholder || this.$t('label.all');
        this.countSelected = '';

        return { color: '#a5a7ad' };
      } else {
        return { color: '#000' };
      }
    },
    styleTextSelected() {
      let style = {};

      style['width'] = 'auto';
      style['text-overflow'] = 'ellipsis';
      style['max-width'] = '100%';
      return style;
    },
    getWidthDropDown() {
      if (this.isSummary) return 'width: 236px';
      if (this.isEventFiltering) return 'width: 180px';
      return '';
    },
    // 선택 텍스트
    getSelectedText() {
      let result = '';
      for (let i = 0; i < this.selectedList.length; i++) {
        let _item = this.selectedList[i];
        result += (0 < result.length ? ', ' : '') + _item.text;
      }
      return 0 < result.length ? result : this.$t('message.dropdownExtMessage');
    },
    getSelectedColor() {
      return this.selectedList.length ? '#333333' : '#a5a7ad';
    },
    // 필터목록
    getFilterItems() {
      let findItems = [];

      if (this.selectAll) {
        this.searchResult = '';
      }
      for (let i = 0; i < this.items.length; i++) {
        let _item = this.items[i];
        _item['check'] = false;
        if (!this.eventFiltering) {
          _item['idx'] = i;
        }
        if (this.filterText && 0 < this.filterText.length) {
          if (-1 < _item['text'].toLowerCase().indexOf(this.filterText.toLowerCase().trim())) {
            findItems.push(_item);
          }
        } else {
          findItems.push(_item);
        }
      }

      if (findItems.length) {
        this.searchResult = this.$t('label.searchResultParam', ['(' + findItems.length + ')']);
      }

      // 체크여부
      for (let i = 0; i < findItems.length; i++) {
        let _item = findItems[i];
        let selectedIndex = this.selectedList.findIndex((row) => row.value === _item.value);
        if (-1 < selectedIndex) {
          _item['check'] = true;
        }
        this.selectedList.forEach((item) => {
          if (item.value === _item.value) {
            item.idx = _item.idx;
          }
        });
      }

      return findItems;
    },
    // selectbox 접기/펼치기 스타일
    caretStyle() {
      let style = {};
      if (this.isItemShowing) {
        style['transform'] = 'rotate(-180deg)';
      }
      style['transition-duration'] = '0.3s';
      return style;
    }
  },
  mounted() {
    this.selectedList = this.modelValue;
    this.getSelectedItemText();
  },
  methods: {
    clickSelectAll() {
      const ableItem = this.items.filter((item) => {
        return !item.disabled;
      });

      if (this.maxSelect && ableItem.length > this.maxSelect) {
        this.hasError = true;
        this.errorMessage = this.messageErrorMaxSelect;
        return;
      }

      // Uncheck
      if (this.selectAllCheckedIcon == 'checked') {
        this.getFilterItems.map((item) => {
          const indexSelectedInAll = this.selectedList.findIndex(
            (itemAll) => item.value === itemAll.value
          );
          indexSelectedInAll > -1 && this.selectedList.splice(indexSelectedInAll, 1);
        });
      } else {
        this.getFilterItems.map((item) => {
          const indexSelectedInAll = this.selectedList.findIndex(
            (itemAll) => item.value === itemAll.value
          );
          indexSelectedInAll === -1 && this.selectedList.push({ ...item, check: true });
        });
      }

      this.getSelectedItemText();
      this.$emit('update:modelValue', this.selectedList.slice());
      this.$emit('clickAll', this.selectedList.slice(), this.rowId);
    },
    getSelectedItemText() {
      this.isShowTooltip = false;

      this.selectedList = this.selectedList.filter((se) => {
        return this.items.some((item) => item.objectName == se.objectName);
      });

      if (this.selectedList.length === 0 || this.selectedList.length === this.items.length) {
        this.textSelected = this.$t('label.all');
        this.countSelected = '';
        this.textToolTip = '';
      } else {
        let itemText = [];

        let firstIdx = 0;
        const count = this.selectedList.length;

        itemText.push(this.selectedList[firstIdx].text);

        this.textToolTip = itemText.toString();
        this.textSelected = itemText.toString();
        this.countSelected = '';

        if (count >= 2) {
          this.isMultiSelect = true;
          this.textToolTip = this.textToolTip + ' ' + this.$t('label.andOther', [count - 1]);
          this.countSelected = this.$t('label.andOther', [count - 1]);
        } else {
          this.isMultiSelect = false;
          this.countSelected = '';
        }

        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        context.font = getComputedStyle(document.body).font;
        let widthDiv = this.$refs.widthDiv.clientWidth;
        let widthSpan = Math.ceil(context.measureText(this.textToolTip).width);

        if (widthSpan > widthDiv) {
          this.isShowTooltip = true;
        }
      }
    },
    filterTextOnInput() {},
    getTagText(item, isTooltip = false) {
      return isTooltip
        ? item.text
        : item.text.replace(
            new RegExp(this.filterText, 'ig'),
            (w) => "<span style='color:#2c59d9'>" + w + '</span>'
          );
    },
    // 아이템체크항목 클릭
    itemCheckOnClick(item) {
      let selectedIndex = this.selectedList.findIndex((row) => row.value === item.value);
      if (-1 < selectedIndex) {
        this.selectedList.splice(selectedIndex, 1);
        this.$emit('delete', false, item, this.rowId);
      } else {
        this.selectedList.push(item);
        this.$emit('update:modelValue', this.selectedList.slice());
        this.$emit('customClick', true, item, this.rowId);
      }

      if (!this.eventFiltering) {
        this.getSelectedItemText();
      }
    },
    // 아이템체크항목 클릭
    isItemCheck(item) {
      return true;
    },
    changeIcon(item) {
      return item.check ? 'check' : 'checkbox';
    },
    // dropdown 토글
    toggleDropdown() {
      this.isItemShowing = !this.isItemShowing;
      // if(this.isItemShowing){
      //   this.$refs.input.focus();
      // }
    },
    // dropdown 닫기
    toggleItemOuter() {
      this.isItemShowing = false;
    },
    clearInputSearch() {
      this.filterText = '';
    }
  }
};
</script>

<style lang="scss" scoped>
.lego-dropdown-check-wrap {
  position: relative;
  .dropdown-toggle {
    display: flex;
    background: #ffffff;
    border: 1px solid #a5a7ad;
    justify-content: space-between;
    height: 32px;
    padding: 0px 10px 0px 12px;
    border-radius: 2px;
    cursor: pointer;
    &.is-item-showing {
      border-color: $lego-dropdown__title__border--focus;
    }
    &:focus {
      border: $lego-dropdown__title__border;
    }
    &:hover {
      border-color: $lego-dropdown__title__border--focus;
    }
    .lego-dropdown__selected {
      width: calc(100% - 15px);
    }

    span {
      display: block;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
  }

  .dropdown-submenu {
    z-index: 9999;
    position: absolute;
    margin-top: -1px;
    width: 100%;
    background-color: #fff;
    border: solid 1px var(--blue-with-a-hint-of-purple);
  }

  .search-result {
    padding-left: 12px;
    font-size: 12px;
    color: #999999;
    margin: 5px 0;
  }

  .no-result {
    cursor: default;
    padding: 25px 0;
    text-align: center;
    font-size: 11px;
    color: #858585;
  }

  :deep .auto-complete__search-box {
    padding: 12px 12px 0px 12px;
  }

  :deep .lego-text-field {
    min-width: 0;
  }

  .check-search-box {
    padding: 8px 10px;
  }

  .check-item {
    display: flex;
    flex-direction: row;
    height: 34px;
    align-items: center;
    padding: 0 12px;
    align-content: center;
    cursor: pointer;

    &:hover,
    &.selected {
      color: var(--blue-with-a-hint-of-purple);
      font-size: 14px;
      background-color: rgba(54, 79, 199, 0.12);
    }

    .checkbox {
      display: inline-block;
      width: 16px;
      height: 16px;
      padding: 0;
      margin-top: 3px;
      line-height: 16px;
      border-radius: 2px;
      border: solid 1px var(--color-ui-06);
      background-color: #fff;
      overflow: hidden;

      :deep .lego-icon--small {
        font-size: 13px;
      }
    }

    &.selected {
      .checkbox {
        background-color: var(--blue-with-a-hint-of-purple);
        border: 1px solid var(--blue-with-a-hint-of-purple);

        :deep .lego-icon {
          color: #fff;
        }
      }
    }
  }
}
.lego-dropdown__selectall-wrap {
  padding: 0 0px;

  .lego-dropdown__item {
    &:hover {
      background-color: transparent;
    }
  }
}
:deep .lego-dropdown__selectall {
  display: block !important;
  border: 0;
  border-bottom: 1px solid #e4e5e7;
  line-height: 24px;
  min-height: 34px;
  max-height: 48px;
  .checkbox-wrapper {
    margin-top: 6px;
  }

  .lego-dropdown__item .lego-checkbox__checked + .lego-checkbox__label,
  .lego-checkbox__label {
    color: #2f3237 !important;
    font-weight: 700;
    padding-top: 1px;
  }
  &:hover {
    background-color: #eff1fb !important;
  }
}
:deep .lego-dropdown__item {
  padding: 0 12px;

  &.item-checked,
  &:hover {
    background-color: #eff1fb;
    .lego-dropdown__label {
      .lego-checkbox__label {
        color: #2f3237;
        font-weight: 400;
      }
    }
  }
}
:deep .lego-checkbox__icon {
  margin-top: 1px;
}
:deep .lego-dropdown__items {
  // margin-bottom: 42px;
  max-height: initial;
  border: 0;
  overflow-x: hidden;
  overflow-y: hidden;
}
.lego-dropdown__selectall-wrap {
  padding: 0 0px;

  .lego-dropdown__item {
    &:hover {
      background-color: transparent;
    }
  }
}
:deep .widget-null {
  display: table;
  min-height: 130px !important;
  text-align: center;
  width: 100%;
  margin: 0 !important;
  padding: 0 !important;
}
</style>
